import { render, staticRenderFns } from "./ClubsItem.vue?vue&type=template&id=34e17072"
import script from "./ClubsItem.vue?vue&type=script&lang=js"
export * from "./ClubsItem.vue?vue&type=script&lang=js"
import style0 from "./ClubsItem.vue?vue&type=style&index=0&id=34e17072&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports